import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "img-markdown-code-inline-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m5 10.5-2-2 2-2m7 4 2-2-2-2m-2.5-3-2 10" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
